﻿

export function projectsFilter() {
  var selectCounty = document.querySelector("#selectCounty");
  var projectsFilterSubmit = document.querySelector("#projectsFilterSubmit");
  selectCounty.addEventListener("change", () => {
    projectsFilterSubmit.click();
  });

  var communityFormFitlers = document.querySelector(".projects-listing-controls");
  communityFormFitlers.addEventListener("submit", (e) => {
    var scrollPos = window.pageYOffset;
    sessionStorage.setItem('pageYOffset', scrollPos);
  });

  var url = new URL(window.location.href);
  var newPos = sessionStorage.getItem('pageYOffset');
  if ((url.search.includes("c=") || url.search.includes("s=")) && newPos != undefined) {
    document.documentElement.scrollTop = parseInt(newPos);
  }
}